import { graphql, useStaticQuery } from 'gatsby'
import { getCookieValue } from '../../utilities/cookie'
import { IS_EQT_NEXUS, IS_EQT_NEXUS_AU } from '../../utilities/site'
import { isNullOrWhiteSpace } from '../../utilities/string'

type QueryResult = {
  allSanityTwoStepDisclaimer: {
    nodes: {
      introduction: {
        countries: {
          name: string
        }[]
        nonProfessionalInvestorLabel?: string
        professionalInvestorLabel?: string
        selectCountryLabel?: string
        selectCountryPlaceholder?: string
        selectInvestorLabel?: string
      }
    }[]
  }
}

type NexusFormFields = {
  countries?: {
    label?: string
    placeholder?: string
    items?: { label: string; value: string }[]
    selected?: string
  }
  investors?: {
    selectInvestorLabel?: string
    selectInvestorPlaceholder?: string
    professionalInvestorLabel?: string
    nonProfessionalInvestorLabel?: string
  }
}

const isNexus = IS_EQT_NEXUS || IS_EQT_NEXUS_AU

/**
 * Get additional signup form fields for Nexus sites.
 */
const useNexusFormFields: () => NexusFormFields = isNexus
  ? () => {
      const disclaimerQueryResult = useStaticQuery<QueryResult>(graphql`
        query nexusDisclaimerSignupFieldsQuery {
          allSanityTwoStepDisclaimer {
            nodes {
              introduction {
                countries {
                  name
                }
                nonProfessionalInvestorLabel
                professionalInvestorLabel
                selectCountryLabel
                selectCountryPlaceholder
                selectInvestorLabel
              }
            }
          }
        }
      `)

      const disclaimer = disclaimerQueryResult?.allSanityTwoStepDisclaimer?.nodes?.[0]

      if (!disclaimer?.introduction) {
        console.error('No disclaimer set up')
        return {}
      }

      let countries = disclaimer.introduction.countries?.map(country => ({
        label: country.name,
        value: country.name,
      }))

      const countryCookie = getCookieValue('eqt_tsd_investor_origin')
      if (!isNullOrWhiteSpace(countryCookie)) {
        countries = countries.filter(country => country.value === countryCookie)
      }

      const {
        selectInvestorLabel,
        professionalInvestorLabel,
        nonProfessionalInvestorLabel,
      } = disclaimer.introduction

      return {
        countries: {
          label: disclaimer.introduction.selectCountryLabel,
          placeholder: disclaimer.introduction.selectCountryPlaceholder,
          items: countries,
          selected: countryCookie ?? '',
        },
        investors: {
          selectInvestorLabel,
          professionalInvestorLabel,
          nonProfessionalInvestorLabel,
        },
      }
    }
  : // eslint-disable-next-line @typescript-eslint/no-empty-function
    () => ({})

export default useNexusFormFields
